import type { JSX } from "solid-js";

/**
 * Utility component which renders given children multiple times
 * @param count number of times children should be multiplied
 */
const Multiply = (props: { count: number; children: JSX.Element }) => {
	const multiplyChildren = () => {
		const multipliedChildren = [];
		for (let i = 1; i <= props.count; i++) {
			multipliedChildren.push(props.children);
		}
		return multipliedChildren;
	};

	return <>{multiplyChildren()}</>;
};
export default Multiply;
